export default __webpack_public_path__ + "static/lefafa_3_2-f4f892fc2b7088256216ebb51042dec7.webp";